import { Dictionary } from '@shared/dictionary';

import { StoryType } from '../enums';


type StatusOption = {
  value: Stories.StoryStatus,
  label: string
}

export const getStatusOptions = (dictionary: Dictionary): StatusOption[] => {
  return [
    { value: 'Idea', label: dictionary.forms.story.status.idea },
    { value: 'Draft', label: dictionary.forms.story.status.draft },
    { value: 'Review', label: dictionary.forms.story.status.review },
    { value: 'Staged', label: dictionary.forms.story.status.staged },
    { value: 'Ready', label: dictionary.forms.story.status.ready },
    { value: 'Archived', label: dictionary.forms.story.status.archived },
  ];
};

export const getStoryTypeLabel = (dictionary: Dictionary, value: string) => {
  const MAP = {
    [StoryType.Vision]: dictionary.forms.story.storyTypeVision,
    [StoryType.Culture]: dictionary.forms.story.storyTypeCulture,
    [StoryType.Adversity]: dictionary.forms.story.storyTypeAdversity,
    [StoryType.EnergyMomentum]: dictionary.forms.story.storyTypeEnergyMomentum,
    [StoryType.OriginPurpose]: dictionary.forms.story.storyTypeOriginPurpose,
    [StoryType.Transformation]: dictionary.forms.story.storyTypeTransformation,
    [StoryType.Team]: dictionary.forms.story.storyTypeTeam,
    [StoryType.FailureLearning]: dictionary.forms.story.storyTypeFailureLearning,
    [StoryType.Impact]: dictionary.forms.story.storyTypeImpact,
    [StoryType.Legacy]: dictionary.forms.story.storyTypeLegacy,
  };

  return MAP[value];
};
